import React from "react";
import {ButtonBase, Typography, useTheme} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import FileSelector from "../../../../components/FileSelector";
import {AddAPhoto} from "@material-ui/icons";

const useStyle = makeStyles(theme => {
    return {
        root:{
            width: "100%",
            paddingBottom: "100%",
            boxShadow: theme.shadows[1],
            borderRadius: theme.shape.borderRadius,
            "& div":{
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                "& p": {
                    display: "block",
                    position: "absolute",
                    bottom: "10%",
                    width: "100%",
                    textAlign: "center",
                    textTransform: "uppercase",
                    fontWeight: 500
                }
            }
        },
        image: {
            "& div > div":{
                height: "75%",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center"
            }
        },
        upload: {
            "& div":{
                paddingTop: "20%",
                "& > svg":{
                    width: "50%",
                    height: "50%"
                }
            }
        }
    }
})

function BaseImageButton({text, children, ...props}) {
    return <ButtonBase
        focusRipple
        {...props}>
        <div>
            {children}
            <Typography>{text}</Typography>
        </div>
    </ButtonBase>
}

export function ImageButton({text, imageUrl, onClick}){
    const {root, image} = useStyle(useTheme())
    return <BaseImageButton text={text} onClick={onClick} className={`${root} ${image}`}>
        <div style={{backgroundImage: `url(${imageUrl})`}} />
    </BaseImageButton>
}

export function ImageUploadButton({text, onSelected}){
    const {root, upload} = useStyle(useTheme())
    return <FileSelector
        accept="image/*"
        capture="environment"
        onSelected={onSelected}
    >{
        onClick => <BaseImageButton text={text} className={`${root} ${upload}`} onClick={onClick}>
            <AddAPhoto/>
        </BaseImageButton>
    }</FileSelector>
}
